/**
 * Obvious next actions on a person profile — core journey mode.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, ChevronRight, FileText, Mic } from 'lucide-react';
import { Button } from '../ui/button';
import { legacyBookPreviewHref } from '../../utils/legacyBookPreview';
import { getPersonDisplayName } from '../../utils/personArchiveInsight';

export function PersonCoreJourneyActions({ person, onNavigate }) {
  if (!person) return null;
  const name = getPersonDisplayName(person);

  return (
    <section
      className="rounded-2xl border border-[hsl(38_14%_86%)]/70 bg-gradient-to-br from-[hsl(42_30%_99%)] to-[hsl(40_22%_97%)] px-5 py-5 sm:px-6"
      data-testid="person-core-journey-actions"
    >
      <p className="text-[10px] font-semibold uppercase tracking-[0.14em] text-[#8b7355]">Preserve for your family</p>
      <h2 className="mt-1 font-serif text-lg font-light text-[hsl(24_12%_18%)]">
        What would you like to do for {name}?
      </h2>
      <p className="mt-1.5 text-sm leading-relaxed text-muted-foreground">
        Start small. One memory or photo is enough — your Legacy Book grows over time.
      </p>
      <div className="mt-4 flex flex-col gap-2 sm:flex-row sm:flex-wrap">
        <Button type="button" className="rounded-full" onClick={() => onNavigate?.('stories')} data-testid="person-cta-memory">
          <Mic className="mr-2 h-4 w-4" aria-hidden />
          Add a memory
        </Button>
        <Button type="button" variant="outline" className="rounded-full" onClick={() => onNavigate?.('documents')} data-testid="person-cta-photo">
          <FileText className="mr-2 h-4 w-4" aria-hidden />
          Add a photo or document
        </Button>
        <Button asChild variant="outline" className="rounded-full" data-testid="person-cta-legacy-book">
          <Link to={legacyBookPreviewHref(person)}>
            <BookOpen className="mr-2 h-4 w-4" aria-hidden />
            Preview in Legacy Book
            <ChevronRight className="ml-1 h-4 w-4" aria-hidden />
          </Link>
        </Button>
      </div>
    </section>
  );
}

export default PersonCoreJourneyActions;
